import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetSafraEUnidade(filters: any) {
  return useQuery(
    [URL.IMPORTAR_TALHOES.SAFRA_PERIODO, filters],
    async () => {
      const { data } = await http.get(URL.IMPORTAR_TALHOES.SAFRA_PERIODO(filters?.safraid, filters?.unidadeid), {});

      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters.unidadeid,
    }
  );
}

export default useGetSafraEUnidade;